var nurseslounge_myDashboard_myCredentialsVault = {
    init:function($params){
        nurseslounge_myDashboard_myCredentialsVault.verification($params);
        nurseslounge_myDashboard_myProfile.profile_is_complete($params, true);
    },
    my_list:null,
    select_node:null,
    verification:function($params){
        var $myCredentialVaultCenter = $("#nurseslounge-home-my-credential-vault .nurseslounge-home-my-credential-vault-center");
        var $verification = $myCredentialVaultCenter.find("select[name='verification']");
        var $padlock = $myCredentialVaultCenter.find('.padlock-image');
        var $loader = $myCredentialVaultCenter.find('.loader-image');
        $padlock.hide();
        $loader.show();
        nurseslounge_myDashboard_myCredentialsVault.verification_check($params, function(){
            $loader.hide();
            $padlock.show();
            $verification.unbind().change(function(){
                var $that = $(this);
                var $val = $that.val();
                $params = $.extend({}, $params, {verificationType:$val});
                switch($val){
                    case 'email':
                        nurseslounge_myDashboard_myCredentialsVault.email_verification($params);
                        break;
                    case 'phone':
                        nurseslounge_myDashboard_myCredentialsVault.phone_verification($params);
                        break;
                }
            });
        });
    },
    verification_check:function($params, cback){
        var $myCredentialVaultCenter = $("#nurseslounge-home-my-credential-vault .nurseslounge-home-my-credential-vault-center");
        var $code = $myCredentialVaultCenter.data('code');
        if($code) {
            $params = $.extend({}, $params, {code: $code, verificationType: 'verification'});
            nurseslounge_myDashboard_myCredentialsVault.code_request($params, function ($data) {
                if ($data.status == 'success') {
                    var $newParams =  $.extend({}, $params, {section:'welcome'});
                    nurseslounge_myDashboard_myCredentialsVault.verification_section($newParams, function ($chtml) {
                        $myCredentialVaultCenter.html($chtml).promise().done(function () {
                            nurseslounge_myDashboard_myCredentialsVault.list($params);
                        });
                    });
                } else {
                    cback();
                }
            });
        } else {
            cback();
        }
    },
    email_verification:function($params){
        var $myCredentialVaultCenter = $("#nurseslounge-home-my-credential-vault .nurseslounge-home-my-credential-vault-center");
        var $phoneVerification = $myCredentialVaultCenter.find(".phone-verification");
        var $padlock = $myCredentialVaultCenter.find('.padlock-image');
        var $loader = $myCredentialVaultCenter.find('.loader-image');
        nurseslounge_myDashboard_myCredentialsVault.email_verification_validate(function(){
            $padlock.hide();
            $loader.show();
            nurseslounge_myDashboard_myCredentialsVault.verification_request($params, function($data){
                $loader.hide();
                $padlock.show();
                if($data.status == 'success'){
                    var $newParams =  $.extend({}, $params, {section:'enter_code'});
                    nurseslounge_myDashboard_myCredentialsVault.verification_section($newParams, function($chtml){
                        $myCredentialVaultCenter.html($chtml).promise().done(function(){
                            nurseslounge_myDashboard_myCredentialsVault.code($params);
                        });
                    });
                }else{
                    $myCredentialVaultCenter.find('form')[0].reset();
                }
            });
        });
        $phoneVerification.hide();
    },
    phone_verification:function($params){
        var $myCredentialVaultCenter = $("#nurseslounge-home-my-credential-vault .nurseslounge-home-my-credential-vault-center");
        var $phoneVerification = $myCredentialVaultCenter.find(".phone-verification");
        $myCredentialVaultCenter.find("input[name='phone']").mask('000-000-0000');
        var $padlock = $myCredentialVaultCenter.find('.padlock-image');
        var $loader = $myCredentialVaultCenter.find('.loader-image');
        nurseslounge_myDashboard_myCredentialsVault.phone_verification_validate(function($form){
            $padlock.hide();
            $loader.show();
            $params = $.extend({}, $params, libs.getObjForm($form));
            nurseslounge_myDashboard_myCredentialsVault.verification_request($params, function($data){
                $loader.hide();
                $padlock.show();
                if($data.status == 'success'){
                    var $newParams =  $.extend({}, $params, {section:'enter_code'});
                    nurseslounge_myDashboard_myCredentialsVault.verification_section($newParams, function($chtml){
                        $myCredentialVaultCenter.html($chtml).promise().done(function(){
                            nurseslounge_myDashboard_myCredentialsVault.code($params);
                        });
                    });
                }else{
                    $myCredentialVaultCenter.find('form')[0].reset();
                }
            });
        });
        $phoneVerification.show();
    },
    phone_verification_validate:function(cback){
        var $validator;
        try {
            $validator = $("#nurseslounge-home-my-credential-vault .nurseslounge-home-my-credential-vault-center form").validate();
            $validator.destroy();
        }catch (e) {

        }
        $validator = $("#nurseslounge-home-my-credential-vault .nurseslounge-home-my-credential-vault-center form").validate({
            onsubmit: true,
            ignore: "*:not(.validate)",
            debug: true,
            rules: {
                phoneCode: {
                    required: true
                },
                phone: {
                    required: true,
                    minlength: 2,
                    maxlength: 18
                }
            },
            messages: {
                phoneCode: {
                    required: "The code is required"
                },
                phone: {
                    required: "The phone is required",
                    minlength: "The phone must have at least 3 characters",
                    maxlength: "The phone cannot exceed 18 characters",
                }
            },
            errorPlacement: function($error, $element){
                var $ele = $($element);
                var $name = $ele.attr("name");
                if(!$ele.hasClass('is-invalid')){
                    $ele.addClass('is-invalid');
                }
                $("."+$name+"_validate").html($($error).text()).show();
            },
            success: function($error, $element) {
                var $ele = $($element);
                var $name = $ele.attr("name");
                if($ele.hasClass('is-invalid')){
                    $ele.removeClass('is-invalid');
                }
                $("."+$name+"_validate").html('').hide();
            },
            submitHandler: function($form) {
                cback($form);
                return false;
            }
        });
    },
    email_verification_validate:function(cback){
        var $validator;
        try {
            $validator = $("#nurseslounge-home-my-credential-vault .nurseslounge-home-my-credential-vault-center form").validate();
            $validator.destroy();
        }catch (e) {

        }
        cback();
    },
    verification_request:function($params, cback){
        $.ajax({
            url: '/myDashboard/myCredentialsVault/verification/request',
            method: "POST",
            cache:false,
            dataType: "json",
            data:$params,
            success: function ($data) {
                libs.expire($data);
                cback($data);
            }
        });
    },
    verification_section:function($params, cback){
        $.ajax({
            url: '/myDashboard/myCredentialsVault/verification/section',
            method: "POST",
            cache:false,
            dataType: "html",
            data: $params,
            success: function ($chtml) {
                libs.expire($chtml);
                cback($chtml);
            }
        });
    },
    code:function($params){
        var $myCredentialVaultCenter = $("#nurseslounge-home-my-credential-vault .nurseslounge-home-my-credential-vault-center");
        nurseslounge_myDashboard_myCredentialsVault.code_validate(function($form){
            $params = $.extend({}, $params, libs.getObjForm($form));
            nurseslounge_myDashboard_myCredentialsVault.code_request($params, function($data){
                if($data.status == 'success') {
                    var $newParams =  $.extend({}, $params, {section:'welcome'});
                    nurseslounge_myDashboard_myCredentialsVault.verification_section($newParams, function ($chtml) {
                        $myCredentialVaultCenter.html($chtml).promise().done(function(){
                            nurseslounge_myDashboard_myCredentialsVault.list($params);
                        });
                    });
                }else{
                    var $newParams =  $.extend({}, $params, {section:'login'});
                    nurseslounge_myDashboard_myCredentialsVault.verification_section($newParams, function ($chtml) {
                        $myCredentialVaultCenter.html($chtml).promise().done(function () {
                            nurseslounge_myDashboard_myCredentialsVault.verification($params);
                        });
                    });
                }
            });
        });
    },
    code_validate:function(cback){
        var $validator;
        try {
            $validator = $("#nurseslounge-home-my-credential-vault .nurseslounge-home-my-credential-vault-center form").validate();
            $validator.destroy();
        }catch (e) {

        }
        $validator = $("#nurseslounge-home-my-credential-vault .nurseslounge-home-my-credential-vault-center form").validate({
            onsubmit: true,
            ignore: "*:not(.validate)",
            debug: true,
            rules: {
                code: {
                    required: true
                }
            },
            messages: {
                code: {
                    required: "The code is required"
                }
            },
            errorPlacement: function($error, $element){
                var $ele = $($element);
                var $name = $ele.attr("name");
                if(!$ele.hasClass('is-invalid')){
                    $ele.addClass('is-invalid');
                }
                $("."+$name+"_validate").html($($error).text()).show();
            },
            success: function($error, $element) {
                var $ele = $($element);
                var $name = $ele.attr("name");
                if($ele.hasClass('is-invalid')){
                    $ele.removeClass('is-invalid');
                }
                $("."+$name+"_validate").html('').hide();
            },
            submitHandler: function($form) {
                cback($form);
                return false;
            }
        });
    },
    code_request:function($params, cback){
        $.ajax({
            url: '/myDashboard/myCredentialsVault/code/request',
            method: "POST",
            cache:false,
            dataType: "json",
            data:$params,
            success: function ($data) {
                libs.expire($data);
                cback($data);
            }
        });
    },
    list:function($params){
        var $myCredentialVaultCenter = $("#nurseslounge-home-my-credential-vault .nurseslounge-home-my-credential-vault-center");
        var $search = $myCredentialVaultCenter.find("input[name='search']");
        var $close = $myCredentialVaultCenter.find(".close");
        var $list = $myCredentialVaultCenter.find("#nurseslounge-home-my-credential-vault-center-list");
        $list.jstree({
            "core" : {
                "themes" : {
                    "responsive": true
                },
                "data" : function ($obj, cback) {
                    $.ajax({
                        url: '/myDashboard/myCredentialsVault/get',
                        method: "POST",
                        cache:false,
                        dataType: "json",
                        data:$params,
                        success: function ($data) {
                            libs.expire($data);
                            cback.call(this, $data);
                        }
                    });
                },
                "search": {
                    "case_insensitive": true,
                    "show_only_matches" : true
                },
            },
            "types" : {
                "add" : {
                    "icon" : "fa fa-plus text-warning"
                },
                "credential" : {
                    "icon" : "fa fa-key text-warning"
                },
                "picture" : {
                    "icon" : "fa fa-picture-o text-primary"
                }
            },
            "plugins": ["search","types"]
        }).on('search.jstree', function ($nodes, $str) {
            if ($str.nodes.length === 0) {
                $list.jstree(true).hide_all();
            }
        }).on('refresh.jstree', function () {
            var $node;
            if(!nurseslounge_myDashboard_myCredentialsVault.select_node){
                $list.jstree("select_node","ul > li:first");
                $node = $list.jstree("get_selected");
                $list.jstree("open_node", $node, false, true);
            }else{
                $node = nurseslounge_myDashboard_myCredentialsVault.select_node;
                $list.jstree().deselect_all(true);
                setTimeout(function(){
                    $list.jstree("select_node","#"+$node);
                    $node = $list.jstree("get_selected");
                    $list.jstree("open_node", $node, false, true);
                }, 1000);
            }
        }).on('loaded.jstree', function() {
            //$list.jstree('open_all');
            $list.jstree("select_node","ul > li:first");
            var $node = $list.jstree("get_selected");
            $list.jstree("open_node", $node, false, true);
        }).on("select_node.jstree", function ($e, $data) {
            nurseslounge_myDashboard_myCredentialsVault.open_list($data.node);
        });
        $search.on('keyup keydown keypress', function(){
            $list.jstree(true).show_all();
            $list.jstree('search', $(this).val());
        });
        $close.unbind().click(function(){
            nurseslounge_myDashboard_myCredentialsVault.close_request($params, function($data){
                if ($data.status == 'success') {
                    var $newParams =  $.extend({}, $params, {section:'login'});
                    nurseslounge_myDashboard_myCredentialsVault.verification_section($newParams, function ($chtml) {
                        $myCredentialVaultCenter.html($chtml).promise().done(function () {
                            nurseslounge_myDashboard_myCredentialsVault.verification($params);
                        });
                    });
                }
            });
        });
        nurseslounge_myDashboard_myCredentialsVault.my_list = $list;
    },
    close_request:function($params, cback){
        $.ajax({
            url: '/myDashboard/myCredentialsVault/verification/close',
            method: "POST",
            cache: false,
            dataType: "json",
            data: $params,
            success: function ($data) {
                libs.expire($data);
                cback($data);
            }
        });
    },
    refresh_list:function($params){
        var $list = nurseslounge_myDashboard_myCredentialsVault.my_list;
        $.ajax({
            url: '/myDashboard/myCredentialsVault/get',
            method: "POST",
            cache: false,
            dataType: "json",
            data: $params,
            success: function ($data) {
                libs.expire($data);
                $list.jstree(true).settings.core.data = $data;
                $list.jstree(true).refresh(true);
            }
        });
    },
    open_list:function($node){
        var $nursesloungeHomeMyCredentialVault = $("#nurseslounge-home-my-credential-vault .nurseslounge-home-my-credential-vault-center");
        var $vaultWrapper = $nursesloungeHomeMyCredentialVault.find(".vault-wrapper");
        var $nodeId = $node.id;
        var $nodeType = $node.type;
        var $nodeText = $node.text;
        var $params = {nodeType:$nodeType, nodeId:$nodeId, user_id:libs.memoryGet('user_id')};
        nurseslounge_myDashboard_myCredentialsVault.section_request($params, function($chtml){
            libs.checkImageLoad($($chtml).find('img'), function(){
                $vaultWrapper.html($chtml).promise().done(function(){
                    var $states = $vaultWrapper.find('select[name="states"]');
                    var $selectAllStates = $vaultWrapper.find('.select-all-states');
                    var $unselectAllStates = $vaultWrapper.find('.unselect-all-states');
                    var $expirationDate = $vaultWrapper.find('.expiration_date');
                    var $resetExpirationDate = $vaultWrapper.find('.reset_expiration_date');
                    var $tag = $vaultWrapper.find('select[name="tag"]');
                    var $otherTag = $vaultWrapper.find('.otherTag');
                    var $delete = $vaultWrapper.find('.delete');
                    var $addPicture = $vaultWrapper.find('.add-picture');
                    var $myPicture = $vaultWrapper.find('.picture-image');
                    var $recognizeImage = $vaultWrapper.find('.recognize-image');
                    try{
                        $states.chosen('destroy');
                    }catch (e) {}
                    $states.chosen();
                    $selectAllStates.unbind().click(function(){
                        $states.find('option').prop('selected', true);
                        $states.trigger('chosen:updated');
                    });
                    $unselectAllStates.unbind().click(function(){
                        $states.find('option').prop('selected', false);
                        $states.trigger('chosen:updated');
                    });
                    $expirationDate.datepicker().on("show", function() {
                        $(".datepicker").css("marginTop", "70px");
                    });
                    $resetExpirationDate.unbind().click(function(){
                        $expirationDate.val("").datepicker("update");
                    });
                    $tag.unbind().change(function(){
                        var $that = $(this);
                        var $val = $that.val();
                        if($val == 'Other'){
                            $otherTag.show();
                        }else{
                            $otherTag.hide();
                        }
                    });
                    if($tag.val() == 'Other'){
                        $otherTag.show();
                    }else{
                        $otherTag.hide();
                    }
                    switch($nodeType){
                        case 'add':
                            nurseslounge_myDashboard_myCredentialsVault.type_add_validate(function($form){
                                $params = $.extend({}, $params, libs.getObjForm($form));
                                nurseslounge_myDashboard_myCredentialsVault.update_request($params, function($data){
                                    nurseslounge_myDashboard_myCredentialsVault.select_node = $data.data.select_node;
                                    nurseslounge_myDashboard_myCredentialsVault.refresh_list($params);
                                });
                            });
                            break;
                        case 'credential':
                            $delete.unbind().click(function(){
                                $params = $.extend({}, $params, {action:'delete'});
                                nurseslounge_myDashboard_myCredentialsVault.update_request($params, function($data){
                                    nurseslounge_myDashboard_myCredentialsVault.select_node = null;
                                    nurseslounge_myDashboard_myCredentialsVault.refresh_list($params);
                                });
                            });
                            $addPicture.unbind().click(function(){
                                nurseslounge_myDashboard_myCredentialsVault.add_picture($params, function($from, $picture){
                                    var $formData = new FormData();
                                    $formData.append('_token', $('meta[name="csrf-token"]').attr('content'));
                                    $formData.append('user_id', libs.memoryGet('user_id'));
                                    $formData.append('nodeType', $nodeType);
                                    $formData.append('nodeId', $nodeId);
                                    $formData.append('name', $nodeText);
                                    $formData.append('action', 'addPicture');
                                    $formData.append('from', $from);
                                    $formData.append('picture', $picture);
                                    nurseslounge_myDashboard_myCredentialsVault.update_request_files($formData, function($data){
                                        nurseslounge_myDashboard_myCredentialsVault.select_node = $data.data.select_node;
                                        nurseslounge_myDashboard_myCredentialsVault.refresh_list($params);
                                    });
                                });
                            });
                            nurseslounge_myDashboard_myCredentialsVault.type_add_validate(function($form){
                                $params = $.extend({}, $params, libs.getObjForm($form), {action:'save'});
                                nurseslounge_myDashboard_myCredentialsVault.update_request($params, function($data){
                                    nurseslounge_myDashboard_myCredentialsVault.select_node = $data.data.select_node;
                                    nurseslounge_myDashboard_myCredentialsVault.refresh_list($params);
                                });
                            });
                            break;
                        case 'picture':
                            $delete.unbind().click(function(){
                                $params = $.extend({}, $params, {action:'delete'});
                                nurseslounge_myDashboard_myCredentialsVault.update_request($params, function($data){
                                    nurseslounge_myDashboard_myCredentialsVault.select_node = $data.data.select_node;
                                    nurseslounge_myDashboard_myCredentialsVault.refresh_list($params);
                                });
                            });
                            $recognizeImage.unbind().click(function(){
                                $recognizeImage.html('Looking for words...').attr('disabled', true);
                                nurseslounge_myDashboard_myCredentialsVault.recognize_text(this, $myPicture.attr('src'), $tagify);
                            });
                            nurseslounge_myDashboard_myCredentialsVault.type_add_validate(function($form){
                                $params = $.extend({}, $params, libs.getObjForm($form), {action:'save'});
                                nurseslounge_myDashboard_myCredentialsVault.update_request($params, function($data){
                                    nurseslounge_myDashboard_myCredentialsVault.select_node = $data.data.select_node;
                                    nurseslounge_myDashboard_myCredentialsVault.refresh_list($params);
                                });
                            });
                            break;
                    }
                });
            });
        });
    },
    section_request:function($params, cback){
        $.ajax({
            url: '/myDashboard/myCredentialsVault/getSection',
            method: "POST",
            cache:false,
            dataType: "html",
            data: $params,
            success: function ($chtml) {
                libs.expire($chtml);
                cback($chtml);
            }
        });
    },
    type_add_validate:function(cback){
        var $validator;
        try {
            $validator = $("#nurseslounge-home-my-credential-vault .nurseslounge-home-my-credential-vault-center .vault-wrapper form").validate();
            $validator.destroy();
        }catch (e) {

        }
        $validator = $("#nurseslounge-home-my-credential-vault .nurseslounge-home-my-credential-vault-center .vault-wrapper form").validate({
            onsubmit: true,
            ignore: "*:not(.validate)",
            debug: true,
            rules: {
                name: {
                    required: true
                },
                expirationDate: {
                    required: false
                },
                states: {
                    required: false
                },
                tag: {
                    required: false
                },
                otherTag: {
                    required: function(){
                        return $("#nurseslounge-home-my-credential-vault .nurseslounge-home-my-credential-vault-center .vault-wrapper").find('select[name="tag"]').val() == 'Other';
                    }
                },
            },
            messages: {
                name: {
                    required: "The name is required"
                },
                expirationDate: {
                    required: "The expiration date is not required"
                },
                states: {
                    required: "The states is not required"
                },
                tag: {
                    required: "The credential keywords is not required"
                },
                otherTag: {
                    required: "The other credential keywords is required"
                },
            },
            errorPlacement: function($error, $element){
                var $ele = $($element);
                var $name = $ele.attr("name");
                if(!$ele.hasClass('is-invalid')){
                    $ele.addClass('is-invalid');
                }
                $("."+$name+"_validate").html($($error).text()).show();
            },
            success: function($error, $element) {
                var $ele = $($element);
                var $name = $ele.attr("name");
                if($ele.hasClass('is-invalid')){
                    $ele.removeClass('is-invalid');
                }
                $("."+$name+"_validate").html('').hide();
            },
            submitHandler: function($form) {
                cback($form);
                return false;
            }
        });
    },
    update_request:function($params, cback){
        $.ajax({
            url: '/myDashboard/myCredentialsVault/set',
            method: "POST",
            cache: false,
            dataType: "json",
            data: $params,
            success: function ($data) {
                libs.expire($data);
                cback($data);
            }
        });
    },
    update_request_files:function($formData, cback){
        $.ajax({
            type: 'POST',
            url: '/myDashboard/myCredentialsVault/set',
            data: $formData,
            cache: false,
            contentType: false,
            processData: false,
            success: function ($data) {
                libs.expire($data);
                cback($data);
            }
        });
    },
    recognize_text:async function($that, $src, $tagify){
        var $words = [];
        var $worker = new Tesseract.createWorker();
        await $worker.load();
        await $worker.loadLanguage('eng');
        await $worker.initialize('eng');
        var $text = await $worker.recognize($src);
        await $worker.terminate();
        if($text){
            $.each($text.data.words, function($i, $v){
                $words.push($v.text);
            });
        }
        $words.sort();
        $words = $.unique($words);
        $tagify.addTags($words);
        $($that).html('Auto Tag').attr('disabled', false);
    },
    add_picture:function($params, cback){
        var $pictureModal = $("#nurseslounge-credential-vault-add-picture-modal");
        $pictureModal.find(".camera").unbind().click(function(){
            $pictureModal.find(".camera-container").fadeOut();
            $pictureModal.find(".storage-container").fadeOut();
            $pictureModal.find(".qr-container").fadeOut();
            nurseslounge_myDashboard_myCredentialsVault.add_picture_animation(function(){
                nurseslounge_myDashboard_myCredentialsVault.add_picture_animation_attach_camera(function($from, $picture){
                    cback($from, $picture);
                    $pictureModal.modal('hide');
                });
            });
        });
        $pictureModal.find(".storage").unbind().click(function(){
            $pictureModal.find(".camera-container").fadeOut();
            $pictureModal.find(".storage-container").fadeOut();
            $pictureModal.find(".qr-container").fadeOut();
            nurseslounge_myDashboard_myCredentialsVault.add_picture_animation(function(){
                nurseslounge_myDashboard_myCredentialsVault.add_picture_from_storage(function($from, $picture){
                    cback($from, $picture);
                    $pictureModal.modal('hide');
                });
            });
        });
        $pictureModal.find(".qr-code").unbind().click(function(){
            $pictureModal.find(".camera-container").fadeOut();
            $pictureModal.find(".storage-container").fadeOut();
            $pictureModal.find(".qr-container").fadeOut();
            nurseslounge_myDashboard_myCredentialsVault.add_picture_animation(function(){
                nurseslounge_myDashboard_myCredentialsVault.add_picture_from_qr($params, function($from, $picture){
                    cback($from, $picture);
                    $pictureModal.modal('hide');
                });
            });
        });
        $pictureModal.unbind().on('hidden.bs.modal', function () {
            $pictureModal.find(".storage-file").val('');
            $pictureModal.find(".camera-container").show();
            $pictureModal.find(".storage-container").show();
            $pictureModal.find(".qr-container").show();
            $pictureModal.find(".modal-body").css('height', 'auto');
            $pictureModal.find(".camera-buttons").hide();
            $pictureModal.find(".save-camera-picture").hide();
            $pictureModal.find(".take-camera-picture").hide();
            $pictureModal.find(".my-camera").html('');
            $pictureModal.find(".image-buttons").hide();
            $pictureModal.find(".save-image-picture").hide();
            $pictureModal.find(".take-image-picture").hide();
            $pictureModal.find(".qr-buttons").hide();
            $pictureModal.find(".take-qr-picture").hide();
            $pictureModal.find(".save-qr-picture").hide();
            Webcam.reset();
        }).modal('show');
    },
    add_picture_animation:function(cback){
        var $pictureModal = $("#nurseslounge-credential-vault-add-picture-modal");
        $pictureModal.find(".my-camera").fadeIn();
        $pictureModal.find(".modal-body").animate({
            "height": "400px"
        }, 500, "linear", function() {
            cback();
        });
    },
    add_picture_animation_attach_camera:function(cback){
        var $pictureModal = $("#nurseslounge-credential-vault-add-picture-modal");
        $pictureModal.find(".my-camera").html('').promise().done(function(){
            Webcam.reset();
            Webcam.attach($pictureModal.find(".my-camera")[0]);
            $pictureModal.find(".camera-buttons").fadeIn();
            $pictureModal.find(".save-camera-picture").unbind().hide();
            $pictureModal.find(".take-camera-picture").html('Take Picture').unbind().click(function(){
                var $pictureModal = $("#nurseslounge-credential-vault-add-picture-modal");
                Webcam.snap( function($imageBase64) {
                    $pictureModal.find(".my-camera").html('<img src="'+$imageBase64+'">').promise().done(function(){
                        $pictureModal.find(".take-camera-picture").html('Reset').unbind().click(function(){
                            nurseslounge_myDashboard_myCredentialsVault.add_picture_animation_attach_camera(cback);
                        });
                        $pictureModal.find(".save-camera-picture").unbind().click(function(){
                            var $blob = libs.b64toBlob($imageBase64);
                            cback('camera', $blob);
                        }).show();
                    });
                });
            }).show();
        });
    },
    add_picture_from_storage:function(cback){
        var $pictureModal = $("#nurseslounge-credential-vault-add-picture-modal");
        $pictureModal.find(".image-buttons").fadeIn();
        $pictureModal.find(".save-image-picture").unbind().hide();
        $pictureModal.find(".my-camera").html('').promise().done(function(){
            $pictureModal.find(".storage-file").val('').unbind().change(function(){
                var $that = this;
                $pictureModal.find(".my-camera").html('<img src="data:,">').promise().done(function(){
                    libs.renderImage($that, $pictureModal.find(".my-camera img:first")[0]);
                    $pictureModal.find(".take-image-picture").html('Reset').unbind().click(function(){
                        nurseslounge_myDashboard_myCredentialsVault.add_picture_from_storage(cback);
                    });
                    $pictureModal.find(".save-image-picture").click(function(){
                        var $files = $($that)[0].files;
                        if($files != ''){
                            cback('storage', $files[0]);
                        }
                    }).show();
                });
            }).click();
            $pictureModal.find(".take-image-picture").html('Select New Picture').unbind().click(function(){
                $pictureModal.find(".storage-file").click();
            }).show();
        });
    },
    add_picture_from_qr:function($params, cback){
        var $pictureModal = $("#nurseslounge-credential-vault-add-picture-modal");
        $pictureModal.find(".qr-buttons").fadeIn();
        $pictureModal.find(".my-camera").html('').promise().done(function(){
            $pictureModal.find(".take-qr-picture").unbind().click(function(){
                $pictureModal.find(".save-qr-picture").hide();
                $.ajax({
                    url: '/myDashboard/myCredentialsVault/getQr',
                    method: "POST",
                    cache: false,
                    dataType: "json",
                    data: $params,
                    success: function ($data) {
                        libs.expire($data);
                        $pictureModal.find(".my-camera").html('<img src="data:image/png;base64,'+$data.data.qr+'">').promise().done(function(){
                            try{
                                clearTimeout(nurseslounge_myDashboard_myCredentialsVault.search_picture_binding);
                            }catch ($e){

                            }
                            nurseslounge_myDashboard_myCredentialsVault.search_picture($data.data.hash, cback);
                        });
                    }
                });
            }).show().click();
        });
    },
    search_picture_binding:null,
    search_picture:function($hash, cback){
        var $pictureModal = $("#nurseslounge-credential-vault-add-picture-modal");
        $.ajax({
            url: '/myDashboard/myCredentialsVault/verifyQr',
            method: "POST",
            cache: false,
            dataType: "json",
            data: {hash:$hash, user_id:libs.memoryGet('user_id')},
            success: function ($data) {
                libs.expire($data);
                if($data.status == 'success'){
                    $pictureModal.find(".my-camera").html('<img src="'+$data.data.image+'">').promise().done(function(){
                        $pictureModal.find(".save-qr-picture").unbind().click(function(){
                            var $blob = libs.b64toBlob($data.data.image);
                            cback('qr', $blob);
                        }).show();
                    });
                }else{
                    nurseslounge_myDashboard_myCredentialsVault.search_picture_binding = setTimeout(function(){
                        nurseslounge_myDashboard_myCredentialsVault.search_picture($hash, cback);
                    }, 1000);
                }
            }
        });
    }
};
